import React from 'react';
import CreditMemoRequestItem from '../../../Domain/CreditMemo/CreditMemoRequestItem';
import ButtonRow from '../../../Elements/ButtonRow';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ErrorMessage from '../../../Elements/ErrorMessage';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import CreditMemoRequestService from '../../../Services/CreditMemo/CreditMemoRequestService';
import CreditMemoRequestSearchParams from './CreditMemoRequestSearchParams';
import EditCreditMemoRequestWindowDescription from './EditCreditMemoRequestWindowDescription';
import CreditMemoStatusChangeWindowDescription from './CreditMemoStatusChangeWindowDescription';

export default class CreditMemoRequestAdmin extends React.Component {
  static defaultProps = {
    clientInvoiceId: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      shownPanel: CreditMemoRequestSearchParams.isThereAnySearchParameter()
        ? ShownPanelsEnum.Search
        : ShownPanelsEnum.None,
      searchItem: new CreditMemoRequestSearchParams(),
      selectedItem: null,
    };
    if (this.props.clientInvoiceId) {
      this.state.searchItem.ClientInvoiceId = this.props.clientInvoiceId;
      this.state.searchItem.SelectedOfficeIds = [];
    }

    this.showPanel = this.showPanel.bind(this);
    CreditMemoRequestItem.editFunction = this.clickOnEditIcon.bind(this);
    CreditMemoRequestItem.statusChangeFunction = this.statusChangeFunction.bind(this);
  }

  startSearch(searchItem) {
    this.setState({ searchItem: searchItem });
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderButtonsAndPanels() {
    return (
      <>
        {this.props.clientInvoiceId ? null : (
          <ButtonRow
            tooltips={['Create']}
            colors={[ButtonColorsEnum.Primary]}
            keys={[ShownPanelsEnum.AddNewItem]}
            icons={['fa-solid fa-plus-circle']}
            roleKeys={['creditmemo_editbuttonrowbutton']}
            value={this.state.shownPanel}
            onClick={this.showPanel}
          />
        )}
        {this.renderPanels()}
      </>
    );
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  renderPanels() {
    const newItem = new CreditMemoRequestItem();
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={newItem}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={EditCreditMemoRequestWindowDescription}
            errorCode={'CMRA77'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={EditCreditMemoRequestWindowDescription}
            errorCode={'CMRA88'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.StatusUpdate,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={CreditMemoStatusChangeWindowDescription}
            errorCode={'CMRA106'}
          />
        )}
      </div>
    );
  }

  statusChangeFunction(id, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.StatusUpdate,
      selectedItem: item,
    });
  }

  editPanelOnClose(refresh) {
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  savePanelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
  }

  async clickOnEditIcon(selectedId, selectedItem) {
    CreditMemoRequestService.GetById(selectedItem.CreditMemoRequestId)
      .then((result) => {
        this.updateObjectFieldsForEdit(selectedItem, result);

        this.setState({
          selectedItem,
          shownPanel: ShownPanelsEnum.EditItem,
        });
      })
      .catch(() => {
        this.setState({
          selectedItem: null,
          shownPanel: ShownPanelsEnum.None,
        });
        ErrorMessage.SetErrorMessage('CMRA128');
      });
  }

  updateObjectFieldsForEdit(selectedItem, result) {
    selectedItem.ReasonCode = result.reasonCode;
    selectedItem.OldReasonCode = result.reasonCode;
    selectedItem.AssignedTo = result.assignedTo;
    selectedItem.LineItemCount = result.lineItemCount;
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={CreditMemoRequestItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={CreditMemoRequestService.GetListBySearching}
          convertDBItemsFunction={CreditMemoRequestService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={!this.props.clientInvoiceId}
          searchParamsType={CreditMemoRequestSearchParams}
          clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different ids and names...'
          errorCode='CMRA164'
        />
      </div>
    );
  }
}
